
import Products from '~/components/Products/index.vue'
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
} from '@/helpers/pageSeo'

export default {
  components: { Products },
  middleware: ['returnUrl', 'onlyRedirectProject'],
  async asyncData({ store, route }) {
    const query = route.query
    const filter = {
      page: 1,
      search: '',
      limit: 12,
      type: 2,
      categoryId: -1,
      currency: store.getters['user/getUserIP'].currency,
    }
    if (!isNaN(Number(query.page))) filter.page = query.page
    if (query.q) filter.search = encodeURI(query.q)
    if (!isNaN(Number(query.categoryId)))
      filter.categoryId = Number(query.categoryId)
    await store.dispatch('courses/GET_COURSES', filter)
    return {
      products: store.getters['courses/getCourses'],
      count: store.getters['courses/getCoursesCount'],
      page: filter.page,
      pages: Math.ceil(store.getters['courses/getCoursesCount'] / 12),
      startCount: (filter.page - 1) * 12,
      endCount:
        filter.page * 12 > store.getters['courses/getCoursesCount']
          ? store.getters['courses/getCoursesCount']
          : filter.page * 12,
    }
  },
  head() {
    const pageTitle = `(${this.count}) ${this.$custom$t('type.courses')} | ${this.$store.state.settings.title}`
    const { title, meta, link } = buildPageHead(this, {
      title: pageTitle,
      description: this.$custom$t('seo.pages.courses.description'),
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
  methods: {
    SET_PAGINATION(page) {
      this.page = page
      this.startCount = (page - 1) * 12
      this.endCount =
        page * 12 > this.$store.getters['courses/getCoursesCount']
          ? this.$store.getters['courses/getCoursesCount']
          : page * 12
      this.$store.dispatch('courses/GET_COURSES', {
        page,
        search: '',
        limit: 12,
        type: 2,
        categoryId: -1,
        currency: this.$store.getters['user/getUserIP'].currency,
      })
      document.getElementById('list').scrollIntoView({ behavior: 'smooth' })
    },
  },
}
